import { render, staticRenderFns } from "./InformationChangeReview.vue?vue&type=template&id=188f4b9d&scoped=true"
import script from "./InformationChangeReview.vue?vue&type=script&lang=js"
export * from "./InformationChangeReview.vue?vue&type=script&lang=js"
import style0 from "./InformationChangeReview.vue?vue&type=style&index=0&id=188f4b9d&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "188f4b9d",
  null
  
)

export default component.exports